export const environment = {
  production: true,
  cookieDomain: 'privateimoveis.com',

  baseUrl: 'https://cliente.api.privateimoveis.com/v1',
};
